import React from 'react';
import { WrapperProps, Wrapper } from 'dot-design-system';

interface Props extends WrapperProps {}

function TextIcon(props: Props) {
	return <Wrapper fontSize={22} fontWeight={'bold'} {...props} />;
}

export default TextIcon;
